import * as React from "react";

const UpsellCard = ({
  title,
  description,
  icon,
  cta,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  cta: React.ReactNode;
}) => {
  return (
    <div className="border border-border flex flex-col flex-1 bg-sheet rounded-2xl py-4 pl-6 pr-8">
      <div className="flex justify-between items-center">
        <div className="flex gap-4 items-center">
          {icon}
          <div className="flex flex-col gap-1">
            <span className="header-h4">{title}</span>
            <span className="text-sm">{description}</span>
          </div>
        </div>
        {cta}
      </div>
    </div>
  );
};

export default UpsellCard;
